import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { MEDIA_CENTER_COVER_SIZE } from 'hb-react/backoffice/apps/MediaCenter/constants';

const WrapperContent = ({ children, ...rest }) => {
  const breakpoint = useBreakpoint();

  return (
    <WrapperStyled breakpoint={breakpoint} {...rest}>
      {children}
    </WrapperStyled>
  );
};

export default WrapperContent;

const WrapperStyled = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['breakpoint'].includes(prop),
  })
  .attrs((otherProps) => ({
    ...otherProps,
    width: { _: 'unset', m: '100%' },
  }))`
  aspect-ratio: ${() => MEDIA_CENTER_COVER_SIZE.aspectRatio};
  word-break: break-word;
  border-color: ${({ theme }) => theme.colors.cloud};

  // Needed to force the style in embedly video and link to fit the design
  & video, a {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;
